module.exports = require("@ryuuji3/react-mask-hook");